export const colors = [
    "red",
    "orange",
    "yellow",
    "olive",
    "green",
    "teal",
    "blue",
    "violet",
    "purple",
    "pink",
    "brown",
    "grey",
    "black",
];

export const colorText = {
  "red": "Red",
  "orange": "Orange",
  "yellow": "Yellow",
  "olive": "Olive",
  "green": "Green",
  "teal": "Teal",
  "blue": "Blue",
  "violet": "Violet",
  "purple": "Purple",
  "pink": "Pink",
  "brown": "Brown",
  "grey": "Grey",
  "black": "Black",
}